module.exports = __webpack_public_path__ + "media/services_overview/smart-manage-clipboard-cb874e76.webp";